// extracted by mini-css-extract-plugin
export default {"container":"P4tYdpYsFGsew6Jrd2Na"};